export default __webpack_public_path__ + "static/img0_inspection_form-97aba5a8461d06d47d4cfa989b7aec16.png";